<template>
    <div>
          <!-- 第一部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">功能性产品/</span>
              <span class="title_en_box">洁齿卷棒 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/SmartBonesFunction01.png"
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1200px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
          <strong style="font-size: 20px; color: #2963a4">清洁爱犬口腔卫生<br />狗狗的磨牙工具和伙伴<br /></strong>
          用有益健康的新鲜蔬菜和纯正鸡肉做成，含多种维生素和矿物质，给狗狗制定最完美的饮食配方。<br />别再盲目的喂胖爱宠啦！低脂肪配方，注重狗狗身体健康。<br />狗狗连续啃食磨牙，能有效清洁爱犬口腔卫生，清洁牙龈异物，预防口臭，狗狗牙结石不再继续发展，口味更清新，牙齿更健康。<br />不掉渣设计，告别打扫烦恼！<br />
          <strong>洁齿卷棒有3种口味可供选择： </strong>
          </p>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

           <!-- 标题 -->
           <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿卷棒</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction03.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

                <!-- 标题 -->
                <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨健齿味&amp;地瓜味(迷你)</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction04.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

          <!-- 第二部分 -->
          <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">功能性产品/</span>
              <span class="title_en_box">功能性卷棒 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/SmartBonesFunction05.png"
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1200px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
          <strong style="font-size: 20px; color: #2963a4">集万千宠爱于一身的洁齿卷棒 <br />低脂肪配方，注重狗狗身体健康 <br /></strong>
          每一口，都是精致的营养输送。<br />别再盲目的喂胖爱宠啦！低脂肪配方，注重狗狗身体健康。<br />用有益健康的新鲜蔬菜和纯正鸡肉做成，富含多种维生素和矿物质，给狗狗制定最完美的饮食配方<br />
          <strong>功能性卷棒有3种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction06.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

           <!-- 标题 -->
           <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿卷棒</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction07.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

       <!-- 第三部分 -->
       <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">功能性产品/</span>
              <span class="title_en_box">洁齿卷片</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/SmartBonesFunction08.png"
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1200px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
          <strong style="font-size: 20px; color: #2963a4">集解决狗狗顽皮天性 <br />还将会是它最好的玩伴 <br /></strong>
          狗狗连续啃食磨牙，能有效清洁爱犬口腔卫生，清楚牙龈异物，预防口臭，狗狗牙结石不再继续发展，口味更清新，牙齿更健康。<br />不掉渣设计，告别打扫烦恼！<br />
          <strong>洁齿卷片有3种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction09.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

           <!-- 标题 -->
           <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿卷片</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesFunction10.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

      </div>
    </div>

<!-- 底部栏目 -->
<foot></foot>

    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
     .w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .title_contain_box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    letter-spacing: 1.2px;
    padding: 20px 200px;
    background-color: #2963a4;
    .title_intro_box {
      font-size: 46px;
      color: #fff;
      font-weight: 600;
      text-align: center;
    }
    .title_en_box {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #fff;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.titleBox {
  padding: 4px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}
</style>